import { render } from "./PaymentsView.vue?vue&type=template&id=15c0b59e&scoped=true&ts=true"
import script from "./PaymentsView.vue?vue&type=script&lang=ts"
export * from "./PaymentsView.vue?vue&type=script&lang=ts"

import "./PaymentsView.vue?vue&type=style&index=0&id=15c0b59e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c0b59e"]])

export default __exports__